<template>
  <div>
    <div class="pic">
      <div class="images">
        <h2 style="text-transform: capitalize;">{{ message }}</h2>
        <!-- <div class="image-section">
          <div
            v-for="(image, index) in currentImages"
            :key="index"
            class="images-wrapper"
          >
            <el-image
              :src="image.url"
              :alt="image.name"
              style="width: 70%; height: auto;"
              fit="cover"
              lazy
            ></el-image>
            <div style="font-size: 30px; font-weight: bold;">{{ image.name }}</div>
          </div>
        </div> -->
        <el-table
          :data="currentImages"
          style="width: 60%; margin: 0 auto; font-size: 22px;"
          border
        >
          <el-table-column
            prop="name1"
            label="name"
            width="200"
            show-overflow-tooltip
            class-name="name-column"
            align="center"
            style="font-size: 28px;"
          >
          </el-table-column>
          <el-table-column label="seq-logo" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.url1"
                :alt="scope.row.name1"
                style="width: 70%; height: auto"
                fit="cover"
              ></el-image>
              <!-- 你的图片地址 -->
            </template>
          </el-table-column>
          <el-table-column
            prop="name2"
            label="name"
            width="200"
            show-overflow-tooltip
            class-name="name-column"
            align="center"
            style="font-size: 28px;"
          >
          </el-table-column>
          <el-table-column label="seq-logo" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.url2"
                :alt="scope.row.name2"
                style="width: 70%; height: auto"
                fit="cover"
              ></el-image>
              <!-- 你的图片地址 -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String, // 定义接收一个名为 parentMessage 的 prop
  },
  data() {
    return {
      currentImages: [],
    };
  },
  created() {
    // this.getValidationImg(this.message, "ATATAA");
  },
  methods: {
    async loadImages(project) {
      try {
        const res = await this.$API.reqResValidationImg(project);
        this.currentImages = res.data;
      } catch (error) {
        console.log("Error", error);
        this.currentImages = [];
      }
    },
  },
  watch: {
    // 监听 message prop 的变化
    message: {
      immediate: true, // 组件初始化时立即调用
      handler(newValue) {
        this.loadImages(newValue);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.pic {
  margin-bottom: 30px;
  .images {
    text-align: center; // 保持 h2 文本居中
    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #003164;
    }
    .image-section {
      display: flex;
      justify-content: center; // Flex元素整体居中
      flex-wrap: wrap; // 允许图片换行
      .images-wrapper {
        margin: 0 auto;
        margin-bottom: 100px;
        el-image {
          width: 500px;
          height: 500px;
          margin: 30px; // 设置图片间距
        }
      }
    }
  }
}
</style>

<style scoped>
/* 目标table的唯一类名 */
.your-table-class .el-table__body td {
  border-color: #ff4949; /* 自定义边框颜色 */
}

.your-table-class .el-table__body tr {
  border-bottom: 2px solid #ff4949; /* 自定义行间边框样式 */
}

.your-table-class .el-table__header th {
  border-color: #ff4949; /* 自定义表头边框颜色 */
}

.el-table .cell.el-tooltip {
      font-size: 38px; /* 或者你想要的大小 */
    }

/* 如果需要修改斑马纹（条纹）样式的边框 */
.your-table-class .el-table__row--striped:nth-child(odd) td {
  background-color: #f9f9f9; /* 斑马纹样式行的背景颜色 */
}
</style>
